import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";
import Button from "@mui/material/Button";
import { createTopicsUrl } from "../../helpers/helpCenterUtils.js";

export default function BackToTopicsButton() {
  const history = useHistory();
  return (
    <Button
      variant="text"
      sx={{ mb: 2 }}
      onClick={() => history.push(createTopicsUrl())}
    >
      ← <FormattedMessage id="helpCenter.backToTopics" />
    </Button>
  );
};
